import { AISummaryType } from './useGetAISummary'
import useHasFeature, { AppFeatures, AppSubFeatures } from './useHasFeature'

export const useAIChatSummary = () => {
    const hasFeature = useHasFeature()

    const hasContactLensSummary = hasFeature(AppFeatures.AI_FEATURES, [
        AppSubFeatures.CHAT_SUMMARIES,
    ])
    const hasPreContactSummary = hasFeature(AppFeatures.AI_FEATURES, [
        AppSubFeatures.AI_ACTION_FLOWS_PRE_CONTACT_SUMMARIES_CHAT,
    ])

    const summaryConfig = hasPreContactSummary
        ? { title: 'Catchup', type: AISummaryType.PRE_CONTACT_CHAT }
        : { title: 'AI Summary', type: AISummaryType.VOICE_CHAT }
    const contactLensSummaryConfig = {
        title: 'AI Summary',
        type: AISummaryType.VOICE_CHAT,
    }

    const showAISummary = hasPreContactSummary || hasContactLensSummary
    const showContactLensSummary = hasContactLensSummary && hasPreContactSummary

    return {
        summaryConfig,
        contactLensSummaryConfig,
        showAISummary,
        showContactLensSummary,
    }
}
